/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Update_ButtonInputs */



/**
* | output |
* | --- |
* | "Update Group" |
*
* @param {Edit_Event_Group_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_update_button = /** @type {((inputs?: Edit_Event_Group_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Update-Gruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа обновлений")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de actualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新グループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह को अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de atualização")
	return /** @type {LocalizedString} */ ("Update Group")
});